export interface CensusSelectedColumn {
    type: CensusSelectedColumnType;
    value: number | number[];
    label: string;
}

export enum CensusSelectedColumnType {
    Individual = 'Individual',
    Category = 'Category',
    AgeBand= "AgeBand"
}